import {useQuery} from "@tanstack/react-query";
import {fetchDELETE, fetchGET, fetchPOST, fetchPUT} from "./fetch";
import {useMyMutation} from "./mymutation";

const REACT_QUERY_ID_CMODELS = "cmodels";
const BASE_URL = "/api/cmodels";

const CmodelsQueryConfig = {
    staleTime: 0,
    cacheTime: 1000 * 60 * 5,
}

export const CMODELS_EMPTY = {
    provincie: "",
    sector: "",
    sectornr: "",
    naamVoornaamVoorzitter: "",
    straatNrVoorzitter: "",
    postnrVoorzitter: "",
    telgsmemailVoorzitter: "",

    naamVoornaamOnderVoorzitter: "",
    straatNrOnderVoorzitter: "",
    postnrOnderVoorzitter: "",
    telgsmemailOnderVoorzitter: "",

    naamVoornaamSecretaris: "",
    straatNrSecretaris: "",
    postnrSecretaris: "",
    telgsmemailSecretaris: "",

    naamVoornaamPenningsmeester: "",
    straatNrPenningsmeester: "",
    postnrPenningsmeester: "",
    telgsmemailPenningsmeester: "",

    naamVoornaamTechnischCommisaris: "",
    straatNrTechnischCommisaris: "",
    postnrTechnischCommisaris: "",
    telgsmemailTechnischCommisaris: "",

    naamVoornaamRaadsLid1: "",
    straatNrRaadsLid1: "",
    postNrGemeenteRaadsLid1: "",
    telGsmEmailRaadsLid1: "",

    naamVoornaamRaadsLid2: "",
    straatNrRaadsLid2: "",
    postNrGemeenteRaadsLid2: "",
    telGsmEmailRaadsLid2: "",

    naamVoornaamRaadsLid3: "",
    straatNrRaadsLid3: "",
    postNrGemeenteRaadsLid3: "",
    telGsmEmailRaadsLid3: "",

    naamVoornaamRaadsLid4: "",
    straatNrRaadsLid4: "",
    postNrGemeenteRaadsLid4: "",
    telGsmEmailRaadsLid4: "",

    naamVoornaamRaadsLid5: "",
    straatNrRaadsLid5: "",
    postNrGemeenteRaadsLid5: "",
    telGsmEmailRaadsLid5: "",

    datumOpstelling: "",
    verwerkt:""
};

export function useCmodels() {
    const result = useQuery({
        queryKey: [REACT_QUERY_ID_CMODELS],
        queryFn: async () => await fetchGET(BASE_URL),
        //onError: e => setError(e),
        ...CmodelsQueryConfig
    });
    return {...result, cmodels: result.data};
}


export function useCmodel(id) {
    const result = useQuery({
        queryKey: [REACT_QUERY_ID_CMODELS, id],
        queryFn: async () => id ? await fetchGET(`${BASE_URL}/${id}`) : {},
        //onError: e => setError(e),
        ...CmodelsQueryConfig
    });
    return {...result, cmodel: result.data};
}

export function useCmodelMutations() {
    async function createFunction(cmodel) {
        if (!cmodel) return;
        return await fetchPOST(BASE_URL, cmodel, false);
    }

    async function editFunction(cmodel) {
        if (!cmodel) return;
        return await fetchPUT(`${BASE_URL}/${cmodel.id}`, cmodel);
    }

    async function editAddNewFiles(cmodel) {
        if (!cmodel) return;
        return await fetchPUT(`${BASE_URL}/${cmodel.id}/files`, cmodel.fileId);
    }

    async function deleteFunction(cmodel) {
        return await fetchDELETE(`${BASE_URL}/${cmodel.id}`)
    }

    return {
        createCmodel: useMyMutation(createFunction, REACT_QUERY_ID_CMODELS, cmodel => `Cmodel ${cmodel.title} created`),
        editCmodel: useMyMutation(editFunction, REACT_QUERY_ID_CMODELS, cmodel => `Cmodel ${cmodel.title} modified`),
        editAddNewFiles: useMyMutation(editAddNewFiles, REACT_QUERY_ID_CMODELS, cmodel => `Cmodel ${cmodel.title} modified`),
        deleteCmodel: useMyMutation(deleteFunction, REACT_QUERY_ID_CMODELS, cmodel => `Cmodel ${cmodel.title} deleted.`)
    };

}